import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useOpenableControls } from '../../../../generic-hooks'
import { StaticImage } from '../../../../image'
import { ProductPrescriptionZeroCopaymentDialog } from '../../../../product'

import bannerZeroCopayment from './banner-zero-copayment.png'

export const ProductOverviewPrescriptionZeroCopaymentCard: FC = () => {
  const intl = useIntl()
  const modalControls = useOpenableControls()

  return (
    <>
      <div data-qa-id="product-overview-prescription-bonus-info-banner">
        <button
          aria-haspopup="dialog"
          aria-label={intl.formatMessage({
            id: 'product.overview.zeroCopayment.infoBox',
          })}
          data-qa-id="product-overview-prescription-bonus-info-banner-how-it-works-link"
          onClick={modalControls.handleOpen}
          type="button"
        >
          <StaticImage alt="" aria-hidden src={bannerZeroCopayment} />
        </button>
      </div>
      <ProductPrescriptionZeroCopaymentDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
